import Component from '../vendor/Component'

export default class GiftCardPromo extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)

    this._form = this._elem.querySelector('form')
    this._selectedOptions = []
    this._optionInputs = this._elem.querySelectorAll('[data-gift-card-promo-el="option"]')
    this._variantsString = this._elem.querySelector('[type="application/json"]').textContent;
    this._variantsData = JSON.parse(this._variantsString);
    this._selectedVariant = this._elem.querySelector('[data-gift-card-promo-el="selectedVariant"]')
    this._addToCart = this._elem.querySelector('[data-gift-card-promo-el="formSubmit"]')
  }

  mount() {
    this.setupListeners()
  }

  setupListeners() {
    this._optionInputs.forEach(element => {
      element.addEventListener('change', ()=> {
        this.collectSelectedValues()
      })
    });

    this._form.addEventListener('submit', (event)=> {
      this.handleAddToCart(event)
    })
  }

  collectSelectedValues() {
    this._elem.querySelectorAll('[data-gift-card-promo-el="option"]:checked').forEach(item => {
      const position = parseInt(item.dataset.optionPosition, 10) - 1;
      this._selectedOptions[position] = item.value
    })

    this.currentVariant = this._variantsData.find((variant) => {
      return JSON.stringify(variant.options) === JSON.stringify(this._selectedOptions);
    });

    if (this.currentVariant) {
      this._selectedVariant.value = this.currentVariant.id
      this._addToCart.disabled = false;
      this._addToCart.setAttribute('aria-disabled', 'false');
    }
  }

  handleAddToCart(event) {
    event.preventDefault();

    const formData = {
      'items': [{
        'id': this._selectedVariant.value,
        'quantity': 1
      }]
    };

    window.Cart.add(formData);
  }
}